import { render } from "./AppUserProfile.vue?vue&type=template&id=4bb41eba"
import script from "./AppUserProfile.vue?vue&type=script&lang=js"
export * from "./AppUserProfile.vue?vue&type=script&lang=js"

import "./AppUserProfile.vue?vue&type=style&index=0&id=4bb41eba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__